export const IntegrationProductTypeColumns = {
	model: [
		{
			label: 'Product Id',
			key: 'key',
		},
		{
			label: 'Product Name',
			key: 'label'
		},
	],
	formBuilderConfig: {
		key: {
			DataType: 'String',
			DisplayText: 'Product Id',
			Name: 'key'
		},
		label: {
			DataType: 'String',
			DisplayText: 'Product Name',
			Name: 'label'
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}

export const IntegrationOrganizationColumns = {
	model: [
		{
			label: 'Integration Client Id',
			key: 'integrationClientId'
		},
		{
			label: 'Class Organization Id',
			key: 'classOrganizationId'
		},
		{
			label: 'Class Organization Name',
			key: 'classOrganizationName'
		}
	],
	formBuilderConfig: {
		integrationClientId: {
			DataType: 'String',
			DisplayText: 'Integration Client Id',
			Name: 'integrationClientId',
		},
		classOrganization: {
			DataType: 'Selector',
			DisplayText: 'Class Organization',
			Name: 'classOrganization',
			UIControl: 'Autocomplete',
			UIOptions: {
				FilterName: 'Name',
				Url: '',
				Mapper: {
					id: 'classOrganizationId',
					name: 'classOrganizationName'
				}
			},
			UIEvents: {
				onSelect: ($event: any, formGroup: any, model?: any) => {
					if ($event) {
						formGroup.get('classOrganizationName')?.setValue($event.name);
						formGroup.get('classOrganizationId')?.setValue($event.id);
					}
				}
			}
		},
		classOrganizationName: {
			DataType: 'String',
			DisplayText: 'Class Organization Name',
			Name: 'classOrganizationName',
			hidden: true
		},
		classOrganizationId: {
			DataType: 'String',
			DisplayText: 'Class Organization Id',
			Name: 'classOrganizationId',
			hidden: true
		},
		integrationId: {
			DataType: 'String',
			DisplayText: 'Integration Id',
			Name: 'integrationId',
			hidden: true,
			required: false
		}
	}
}

export const IntegrationDocumentTypeColumns = {
	model: [
		{
			label: 'Integration Id',
			key: 'key'
		},
		{
			label: 'Integration Label',
			key: 'label'
		},
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any) => {

				switch ($event.value) {
					case 'Acuity':
						model[3].options = extraData.acuityOptions;
						break;

					case 'AppScope':
						model[3].options = extraData.appScopeOptions;
						break;

					case 'ClassValuation':
						model[3].options = extraData.classValuationOptions;
						break;

					case 'cmpAcuity':
						model[3].options = extraData.cmpAcuityOptions;
						break;
				}

				if (model[3].options[0]) {
					const selectedValue = model[3].options[0];

					integrationData[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue.value,
							trackingSystemLabel: selectedValue.label
						}
					};
				}
			}
		},
		{
			label: 'Tracking System Option',
			key: 'trackingSystemId',
			type: 'select',
			options: [],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any) => {
				let selectedValue = [];

				switch (row.trackingSystem) {
					case 'Acuity':
						selectedValue = extraData.acuityOptions.filter((option: any) => option.value === $event.value);
						break;

					case 'AppScope':
						selectedValue = extraData.appScopeOptions.filter((option: any) => option.value === $event.value);
						break;

					case 'ClassValuation':
						selectedValue = extraData.classValuationOptions.filter((option: any) => option.value === $event.value);
						break;
				}

				if (selectedValue.length) {
					integrationData[row.id] = { ...row, ...{ trackingSystemId: selectedValue[0].value, trackingSystemLabel: selectedValue[0].label } };
				}
			},
			getValue: (field: any, row: any) => {
				return row['trackingSystemLabel'];
			}
		},
		{
			label: 'Tracking System Id',
			key: 'trackingSystemId',
			disabled: true
		},
		{
			label: 'Tracking System Label',
			key: 'trackingSystemLabel',
			disabled: true
		},
		{
			label: 'Direction',
			key: 'direction',
			type: 'select',
			options: [
				{ label: 'Both', value: 'Both' },
				{ label: 'Output', value: 'Output' },
				{ label: 'Input', value: 'Input' },
			]
		}
	],
	callBacks: {
		onRowEditInit: (row: any, model: any, extraData: any) => {
			switch (row.trackingSystem) {
				case 'Acuity':
					model[3].options = extraData.acuityOptions;
					break;

				case 'AppScope':
					model[3].options = extraData.appScopeOptions;
					break;

				case 'ClassValuation':
					model[3].options = extraData.classValuationOptions;
					break;
			}
		}
	},
	formBuilderConfig: {
		key: {
			DataType: 'String',
			DisplayText: 'Integration Id',
			Name: 'key'
		},
		label: {
			DataType: 'String',
			DisplayText: 'Integration Label',
			Name: 'label',
		},
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			UIControl: 'Dropdown',
			options: [
			],
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					const trackingSystemOptionsName = $event.value[0].toLowerCase() + $event.value.substring(1);
					model['trackingSystemId'].options = extraData[trackingSystemOptionsName];

					if (formGroup) {
						formGroup.get('trackingSystemId')?.setValue(null);
						formGroup.get('trackingSystemLabel')?.setValue(null);
					}
				}
			}
		},
		trackingSystemId: {
			DataType: 'Selector',
			DisplayText: 'Tracking System Option',
			Name: 'trackingSystemId',
			UIControl: 'Dropdown',
			UIOptions: {
				ShowFilter: true
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					let selectedValue = [];

					if (formGroup) {
						const trackingSystem = formGroup.get('trackingSystem')?.value;
						if (trackingSystem) {
							const trackingSystemOptionsName = trackingSystem[0].toLowerCase() + trackingSystem.substring(1);
							selectedValue = extraData[trackingSystemOptionsName]?.filter((option: any) => option.value === $event.value);
						}

						if (selectedValue.length) {
							formGroup.get('trackingSystemId')?.setValue(selectedValue[0].value);
							formGroup.get('trackingSystemLabel')?.setValue(selectedValue[0].label);
						}
					}
				}
			}
		},
		direction: {
			DataType: 'Selector',
			DisplayText: 'Direction',
			Name: 'direction',
			UIControl: 'Dropdown',
			options: [
				{ label: 'Both', value: 'Both' },
				{ label: 'Output', value: 'Output' },
				{ label: 'Input', value: 'Input' },
			]
		},
		trackingSystemLabel: {
			DataType: 'String',
			DisplayText: 'Tracking System Label',
			Name: 'trackingSystemLabel',
			hidden: true
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
};

export const IntegrationMappersColumns = {
	model: [
		{
			label: 'Integration Id',
			key: 'key'
		},
		{
			label: 'Integration Label',
			key: 'label'
		},
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'Acuity', value: 'cmpAcuity' },
			],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any) => {

				switch ($event.value) {
					case 'Acuity':
						model[3].options = extraData.acuityOptions;
						break;
					case 'AppScope':
						model[3].options = extraData.appScopeOptions;
						break;
					case 'cmpAcuity':
						model[3].options = extraData.appScopeOptions;
						break;
					default:
						model[3].options = [];
						break;

				}

				if (model[3].options[0]) {
					const selectedValue = model[3].options[0];

					integrationData[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue.value,
							trackingSystemLabel: selectedValue.label
						}
					};
				}
			}
		},
		{
			label: 'Tracking System Option',
			key: 'trackingSystemId',
			type: 'select',
			options: [],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any, formGroup: any) => {
				let selectedValue = [];

				if (row.trackingSystem === 'Acuity') {
					selectedValue = extraData.acuityOptions.filter((option: any) => option.value === $event.value);
				} else {
					selectedValue = extraData.appScopeOptions.filter((option: any) => option.value === $event.value);
				}

				if (selectedValue.length) {
					integrationData[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue[0].value,
							trackingSystemLabel: selectedValue[0].label
						}
					};
				}
			},
			getValue: (field: any, row: any) => {
				return row['trackingSystemLabel'];
			}
		},
		{
			label: 'Tracking System Id',
			key: 'trackingSystemId',
			disabled: true
		},
		{
			label: 'Tracking System Label',
			key: 'trackingSystemLabel',
			disabled: true
		}
	],
	callBacks: {
		onRowEditInit: (row: any, model: any, extraData: any) => {
			if (row.trackingSystem === 'Acuity') {
				model[3].options = extraData.acuityOptions;
			} else {
				model[3].options = extraData.appScopeOptions;
			}
		}
	},
	formBuilderConfig: {
		key: {
			DataType: 'String',
			DisplayText: 'Integration Id',
			Name: 'key'
		},
		label: {
			DataType: 'String',
			DisplayText: 'Integration Label',
			Name: 'label'
		},
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			UIControl: 'Dropdown',
			options: [],
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					model['trackingSystemId'].options = [];

					if($event.value) {
						const trackingSystemOptionsName = $event.value[0].toLowerCase() + $event.value.substring(1);
						model['trackingSystemId'].options = extraData[trackingSystemOptionsName];
					}

					if (formGroup) {
						formGroup.get('trackingSystemId')?.setValue(null);
						formGroup.get('trackingSystemLabel')?.setValue(null);
					}
				}
			}
		},
		trackingSystemId: {
			DataType: 'Selector',
			DisplayText: 'Tracking System Option',
			Name: 'trackingSystemId',
			UIControl: 'Dropdown',
			options: [],
			UIOptions: {
				ShowFilter: true
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					let selectedValue = [];
					if (formGroup) {
						const trackingSystem = formGroup.get('trackingSystem')?.value;
						if (trackingSystem) {
							const trackingSystemOptionsName = trackingSystem[0].toLowerCase() + trackingSystem.substring(1);
							selectedValue = extraData[trackingSystemOptionsName]?.filter((option: any) => option.value === $event.value);
						}
						if (selectedValue.length) {
							formGroup.get('trackingSystemId')?.setValue(selectedValue[0].value);
							formGroup.get('trackingSystemLabel')?.setValue(selectedValue[0].label);
						}
					}
				}
			}
		},
		trackingSystemLabel: {
			DataType: 'String',
			DisplayText: 'Tracking System Label',
			Name: 'trackingSystemLabel',
			hidden: true
		},
		mapType: {
			DataType: 'String',
			DisplayText: 'Mapper Type',
			Name: 'mapType',
			hidden: true,
			required: false
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}

export const IntegrationInboudOrderStatusColumns = {
	model: [
		{
			label: 'Status',
			key: 'status',
		},
		{
			label: 'Action',
			key: 'action'
		},
	],
	formBuilderConfig: {
		status: {
			DataType: 'String',
			DisplayText: 'Status',
			Name: 'status'
		},
		action: {
			DataType: 'Selector',
			DisplayText: 'Action',
			Name: 'action',
			UIControl: 'Dropdown',
			options: [
			],
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}

export const IntegrationOnHoldClientAccessColumns = {
	model: [
		{
			label: 'Tracking System',
			key: 'trackingSystem',
		},
		{
			label: 'On Hold Reason',
			key: 'holdReasonId'
		},
		{
			label: 'Send To Client?',
			key: 'sendToClient'
		},
		{
			label: 'Receive From Client',
			key: 'receiveFromClient'
		},
	],

	formBuilderConfig: {
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			UIControl: 'Dropdown',
		},
		holdReasonId: {
			DataType: 'Selector',
			DisplayText: 'On Hold Reason',
			Name: 'holdReasonId',
			UIControl: 'Dropdown',
		},
		sendToClient: {
			DataType: 'Boolean',
			SubDataType: 'checkbox',
			DisplayText: 'Send To Client?',
			Name: 'sendToClient',
			required: false,
			defaultValue: false,
			UIOptions: {
				showLabel: true,
				customTemplate: false,
			},
			options: [
				{label: 'No', value: false},
				{label: 'Yes', value: true}
			]
		},
		receiveFromClient: {
			DataType: 'Selector',
			DisplayText: 'Receive From Client',
			Name: 'receiveFromClient',
			UIControl: 'Dropdown',
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}

// trackingSystem: "", // ENUM, form the TrackingSystem endpoint
// message: ""

export const IntegrationMessagesToIgnoreColumns = {
	model: [
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		{
			label: 'Message',
			key: 'message'
		},
	],

	formBuilderConfig: {
		trackingSystem: {
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			type: 'select',
			DataType: 'Selector',
			UIControl: 'Dropdown',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		message: {
			DataType: 'String',
			DisplayText: 'Message',
			Name: 'message'
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}

// 	   trackingSystem: "", // ENUM, form the TrackingSystem endpoint
//     subject: "", string
//     body: "", string
//     createdBy: "", (hidden)
//     handleMode: "" // ENUM, provided by BE

export const IntegrationOnholdClientAccessColumns = {
	model: [
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		{
			label: 'Subject',
			key: 'subject'
		},
		{
			label: 'Body',
			key: 'body',
		},
		{
			label: 'Created By',
			key: 'createdBy'
		},
		{
			label: 'Handle Mode',
			key: 'handleMode',
			type: 'select',
		}
	],

	formBuilderConfig: {
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			type: 'select',
			UIControl: 'Dropdown',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		subject: {
			DataType: 'String',
			DisplayText: 'Subject',
			Name: 'subject'
		},
		body: {
			DataType: 'String',
			DisplayText: 'Body',
			Name: 'body'
		},
		createdBy: {
			DataType: 'String',
			DisplayText: 'Created By',
			Name: 'createdBy',
			hidden: true,
			required: false
		},
		handleMode: {
			DataType: 'Selector',
			DisplayText: 'Handle Mode',
			Name: 'handleMode',
			type: 'select',
			UIControl: 'Dropdown',
			options: [
				{ label: 'AsUnhandledMessage', value: 'AsUnhandledMessage' },
				{ label: 'AsHandledMessage', value: 'AsHandledMessage' },
				{ label: 'Ignore', value: 'Ignore' },
			],
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}

export const OutgoingEventsColumns = {
	model: [
		{
			label: 'Event Name',
			key: 'eventName',
			type: 'select',
			options: [],
		},
		{
			label: 'Post If',
			key: 'postIf',
			type: 'select',
			options: [],
		},
	],

	formBuilderConfig: {
		eventName: {
			DisplayText: 'Event Name',
			Name: 'eventName',
			type: 'select',
			DataType: 'Selector',
			UIControl: 'Dropdown',
			options: [],
		},
		postIf: {
			DisplayText: 'Post If',
			Name: 'postIf',
			type: 'select',
			DataType: 'Selector',
			UIControl: 'Dropdown',
			options: [],
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}